export default {
  installButton: {
    notes: 'Button label for opening the install configuration dialog',
    message: 'Install configuration',
  },
  installSuccessToast: {
    notes:
      'Success toast shown after a configuration has been marked as installed',
    message: 'The configuration has been marked as installed',
  },
  deckAlreadyInstalledTooltip: {
    notes:
      'Tooltip on the disabled install button when another configuration is already installed for the deck',
    message:
      'A configuration is already installed for this deck. Use Deck Maintenance to record changes.',
  },
  missingMediaTooltip: {
    notes:
      'Tooltip on the disabled install button when some deck positions are missing screening media. {{count}} is the number of positions',
    message: '{{count}} positions need media',
  },
  activityName: {
    notes:
      'Name of the automatically created activity when a configuration is installed. {{name}} is the configuration name',
    message: 'Installed {{name}}',
  },
  dialog: {
    title: {
      notes: 'Title of the install configuration dialog',
      message: 'Install as currently installed',
    },
    warningContent: {
      notes:
        'Markdown content for the warning box in the install configuration dialog',
      message:
        '**For initial SAM setup only**\n\n- Records this configuration as currently installed\n- Does not create a maintenance activity\n- Cannot be undone\n- Cannot be repeated once an installation exists',
    },
    dateHeader: {
      notes:
        'Header above the installation date picker in the install configuration dialog',
      message: 'Installation date',
    },
    dateDescription: {
      notes:
        'Explanation below the installation date picker in the install configuration dialog',
      message: 'When was this configuration physically installed?',
    },
    confirmCheckbox: {
      notes: 'Checkbox label confirming the text to confirm before proceeding',
      message: 'I understand this action is permanent and cannot be undone',
    },
    confirmButton: {
      notes: 'Confirm install button label in the install configuration dialog',
      message: 'Install as current',
    },
  },
};
